<template>
  <div style="background-color:#fff;">
    <div class="mb20"
         style="padding-top:20px;">
      <el-radio-group v-model="mode"
                      size="small">
        <el-radio-button label="1">基础档案</el-radio-button>
        <el-radio-button label="2">案件档案</el-radio-button>
      </el-radio-group>
    </div>
    <avue-crud :option="option"
               :search.sync="search"
               :table-loading="loading"
               :data="data"
               ref="crud"
               @row-del="rowDel"
               v-model="form"
               :page.sync="page"
               :permission="permissionList"
               @search-change="searchChange"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @refresh-change="refreshChange"
               @on-load="onLoad"
               @error="error">
      <template slot-scope="{row}"
                slot="followUpVisitRecords">
        <el-tag @click="openfollowUpHandle(row.id)">走访记录</el-tag>
      </template>
      <template slot-scope="{row}"
                slot="basisArchiveNo">
        <div class="num-family">{{row.basisArchiveNo}}</div>
      </template>
      <template slot-scope="{row}"
                slot="caseArchivedNumber">
        <div class="num-family">{{row.caseArchivedNumber}}</div>
      </template>
      <template slot-scope="{row}"
                slot="caseArchivedNo">
        <div class="num-family">{{row.caseArchivedNo}}</div>
      </template>
      <template slot="menuLeft">
        <el-button type="primary"
                   v-if="mode == 1&&permission.archives_add"
                   size="small"
                   icon="el-icon-plus"
                   @click="$router.push('/desk/detail')">新增
        </el-button>
        <el-button type="danger"
                   size="small"
                   plain
                   icon="el-icon-delete"
                   v-if="mode == 1&&permission.archives_del"
                   @click="handleDelete">删除
        </el-button>
        <el-button type="success"
                   size="small"
                   v-if="mode == 1&&permission.archives_import"
                   plain
                   icon="el-icon-upload2"
                   @click="handleImport">导入
        </el-button>
        <el-button type="warning"
                   size="small"
                   v-if="permission.archives_export"
                   plain
                   icon="el-icon-download"
                   @click="handleExport">导出
        </el-button>
      </template>
      <template slot-scope="scope"
                slot="menu">
        <el-button type="text"
                   size="small"
                   v-if="mode == 1&&permission.archives_edit"
                   plain
                   class="none-border"
                   @click.stop="handleEdit(scope.row)">编辑
        </el-button>
        <!--       <el-button type="text" size="small" v-if="mode == 1&&permission.archives_view" plain class="none-border" @click.stop="handleDetail(scope.row)">详情
                </el-button> -->
        <el-button type="text"
                   size="small"
                   v-if="permission.archives_view"
                   plain
                   class="none-border"
                   @click="handlePrintOpen(scope.row.id)">查看
        </el-button>
      </template>
    </avue-crud>
    <el-dialog :title="mode == '1'?'基础档案导入':'案件档案导入'"
               append-to-body
               :visible.sync="excelBox"
               width="555px">
      <avue-form :option="excelOption"
                 v-model="excelForm"
                 :upload-after="uploadAfter">
        <template slot="excelTemplate">
          <el-button type="primary"
                     @click="handleTemplate">
            点击下载<i class="el-icon-download el-icon--right"></i>
          </el-button>
        </template>
      </avue-form>
    </el-dialog>
    <el-dialog title="档案详情"
               append-to-body
               width="80%"
               :visible.sync="orderDetailVisible"
               v-if="orderDetailVisible">
      <pdf :info="detail"
           v-if="mode == 2"
           :type="2"
           :dosserId="dosserId"
           @close="orderDetailVisible = false"></pdf>
      <jcdalPdf :info="detail"
                v-if="mode == 1"
                :type="2"
                @close="orderDetailVisible = false"></jcdalPdf>
    </el-dialog>
    <el-dialog title="跟踪走访记录"
               append-to-body
               :visible.sync="addfollowUpVisit"
               width="555px"
               custom-class="common-dialog">
      <el-timeline :reverse="reverse">
        <el-timeline-item v-for="(item,index) in followUpList"
                          :key="index"
                          :timestamp="`${item.createUserName} ${item.visitTime}`">
          {{item.content}}
        </el-timeline-item>
      </el-timeline>
      <avue-form :option="addfollowUpOption"
                 v-model="addfollowUpForm"
                 ref="addfollowUpForm"
                 @submit="addFollowHandle"></avue-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { getList, getListSuper, getArchivesDetail, remove, removeCasearchived, getSuperDetail } from '@/api/archives/index'
import { addFollowUp, addCaseFollowUp, basisListFollowUp, caseArchivedFollowUp } from '@/api/archives/follow'
import jcdalPdf from '@/views/archives/components/jcda-pdf.vue'
import pdf from '@/views/archives/components/order-detail-pdf.vue'
// import website from '@/config/website';
import { getToken } from '@/util/auth';
import { emptySurplus, serialize } from '@/util/util'
// import { getAttachFile } from "@/api/resource/oss"
export default {
  components: {
    pdf,
    jcdalPdf
  },
  data () {
    return {
      dosserId: '',
      followUpList: [],
      addfollowUpVisit: false,
      addfollowUpForm: {},
      addfollowUpOption: {
        column: [{
          label: '走访类型',
          labelPosition: 'top',
          prop: 'interviewType',
          type: "select",
          dicUrl: "/api/blade-system/dict-biz/dictionary",
          dicQuery: {
            code: 'visit-tracking_method'
          },
          props: {
            label: "dictValue",
            value: "dictKey"
          },
          row: true,
          span: 24
        }, {
          label: '跟踪走访记录',
          labelPosition: 'top',
          prop: 'content',
          type: "textarea",
          row: true,
          span: 24
        },
        {
          label: "上传图片",
          labelPosition: 'top',
          prop: "imgUrls",
          type: 'upload',
          dataType: 'array',
          listType: 'picture-card',
          loadText: '图片上传中，请稍等',
          tip: '只能上传jpg/png/图片，且不超过2MB',
          action: '/api/blade-resource/oss/endpoint/put-file-attach',
          propsHttp: {
            res: 'data',
            url: 'link'
          },
          data: {
            fileName: 'imgUrls'
          },
          span: 24,
          hide: true
        },
        {
          label: '时间',
          labelPosition: 'top',
          prop: 'visitTime',
          type: "datetime",
          format: "yyyy-MM-dd hh:mm:ss",
          valueFormat: "yyyy-MM-dd hh:mm:ss",
          row: true,
          span: 24
        }
        ],
      },
      orderDetailVisible: false,
      detail: {},
      search: {},
      form: {},
      mode: '1',
      selectionId: '',
      selectionList: [],
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      flowBox: false,
      flowUrl: '',
      stateBox: false,
      flowState: '',
      excelBox: false, // 导入
      option: {},
      option1: {
        height: 'auto',
        calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        selection: true,
        editBtn: false,
        addBtn: false,
        viewBtn: false,
        delBtn: true,
        dialogWidth: 900,
        menuWidth: 190,
        searchLabelWidth: 100,
        labelWidth: 110,
        dialogClickModal: false,
        column: [{
          label: '基础档案编号',
          prop: 'basisArchiveNo',
          width: 212,
          search: true,
          searchOrder: 4,
          searchGutter: 5
        },
        {
          label: '类型',
          type: "select",
          dicUrl: "/api/blade-system/dict-biz/dictionary",
          dicQuery: {
            code: 'Five-youth_types'
          },
          formatter: (row, value, label,) => {
            return label
          },
          props: {
            label: "dictValue",
            value: "dictKey"
          },
          prop: "archiveTeenagersType",
          search: true,
          searchGutter: 5
        },
        {
          label: '发布人',
          prop: 'archiveCreateUserName',
          display: false
        },
        {
          label: '姓名',
          prop: 'archiveName',
          search: true,
          searchOrder: 1,
          searchSpan: 6,
          searchGutter: 5
        },
        {
          label: '性别',
          prop: 'archiveGender',
          search: true,
          display: false,
          hide: true,
          searchOrder: 4,
          searchSpan: 6,
          searchGutter: 5
        },
        {
          label: "身份证号",
          prop: "archiveCardNo",
          hide: true,
          display: false,
          search: true,
          searchOrder: 2,
          searchSpan: 6,
          searchGutter: 5
        },
        {
          label: "发布机构",
          prop: 'archiveCreateDeptName',
          display: false,
          search: true,
          searchOrder: 3,
          searchSpan: 6,
          searchGutter: 5
        },
        {
          label: '来源',
          prop: 'source',
          type: "select",
          dicUrl: "/api/blade-system/dict-biz/dictionary",
          dicQuery: {
            code: 'individual_case'
          },
          formatter: (row, value, label,) => {
            if (value * 1 == 0) {
              return "呼叫订单"
            } else {
              return label
            }
          },
          props: {
            label: "dictValue",
            value: "dictKey"
          },
        },
        {
          label: '走访记录',
          prop: 'followUpVisitRecords'
        },
        {
          label: '发布时间',
          prop: 'createTime',
          search: true,
          type: "datetime",
          format: "yyyy-MM-dd hh:mm:ss",
          valueFormat: "yyyy-MM-dd hh:mm:ss",
        }
        ]
      },
      option2: {
        height: 'auto',
        calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        selection: true,
        editBtn: false,
        addBtn: false,
        viewBtn: false,
        delBtn: true,
        dialogWidth: 900,
        menuWidth: 190,
        searchLabelWidth: 100,
        labelWidth: 110,
        dialogClickModal: false,
        column: [{
          label: '案件编号',
          prop: 'caseArchivedNumber',
          width: 135,
          search: true,
          searchOrder: 5,
          searchGutter: 5
        },
        {
          label: '案件档案编号',
          prop: 'caseArchivedNo',
          width: 190,
          search: true,
          searchOrder: 6,
          searchGutter: 5
        },
        {
          label: '类型',
          type: "select",
          dicUrl: "/api/blade-system/dict-biz/dictionary",
          dicQuery: {
            code: 'Five-youth_types'
          },
          formatter: (row, value, label,) => {
            return label
          },
          props: {
            label: "dictValue",
            value: "dictKey"
          },
          prop: "caseArchivedTeenagersType",
          search: true,
          searchGutter: 5
        },
        {
          label: '发布人',
          prop: 'caseArchivedCreateUserName',
          display: false
        },
        {
          label: '姓名',
          prop: 'caseArchivedName',
          search: true,
          searchOrder: 1,
          searchSpan: 6,
          searchGutter: 5
        },
        {
          label: "身份证号",
          prop: "caseArchivedCardNo",
          hide: true,
          display: false,
          search: true,
          searchOrder: 2,
          searchSpan: 6,
          searchGutter: 5
        },
        {
          label: '性别',
          prop: 'archiveGender',
          search: true,
          display: false,
          hide: true,
          searchOrder: 4,
          searchSpan: 6,
          searchGutter: 5
        },
        {
          label: '颜色标注',
          prop: 'archiveColor',
          search: true,
          display: false,
          hide: true,
          searchOrder: 4,
          searchSpan: 6,
          searchGutter: 5
        },
        {
          label: "发布机构",
          prop: 'caseArchivedCreateDeptName',
          display: false,
          search: true,
          searchOrder: 3,
          searchSpan: 6,
          searchGutter: 5
        },
        {
          label: '来源',
          prop: 'caseArchivedSource',
          multiple: true,
          type: "select",
          dicUrl: "/api/blade-system/dict-biz/dictionary",
          dicQuery: {
            code: 'individual_case'
          },
          formatter: (row, value, label,) => {
            if (value * 1 == 0) {
              return "呼叫订单"
            } else {
              return label
            }
          },
          props: {
            label: "dictValue",
            value: "dictKey"
          },
        },
        {
          label: '走访记录',
          prop: 'followUpVisitRecords'
        },
        {
          label: '发布时间',
          prop: 'createTime',
          search: true,
          type: "datetime",
          format: "yyyy-MM-dd hh:mm:ss",
          valueFormat: "yyyy-MM-dd hh:mm:ss",
        }
        ]
      },
      data: [],
      excelForm: {},
      excelOption: {
        submitBtn: false,
        emptyBtn: false,
        column: [{
          label: '模板上传',
          prop: 'excelFile',
          type: 'upload',
          drag: true,
          loadText: '模板上传中，请稍等',
          span: 24,
          tip: '请上传 .xls,.xlsx 标准格式文件',
          action: '/api/blade-resource/oss/endpoint/put-file-attach-by-name-new',
          propsHttp: {
            res: 'data'
          },
          data: {
            fileName: 'dossier'
          },
          // uploadAfter: (res, done) => {
          //     getAttachFile(res).then(res => {
          //         const qrUrl = window.URL.createObjectURL(res.data)
          //         this.orderForm.avatar = qrUrl
          //         this.orderForm.dossier.avatar = qrUrl
          //         done()
          //     })
          //     console.log(this.orderForm)
          // }
        },
        {
          label: "数据覆盖",
          prop: "isCovered",
          type: "switch",
          align: "center",
          width: 80,
          dicData: [{
            label: "否",
            value: 0
          },
          {
            label: "是",
            value: 1
          }
          ],
          value: 0,
          slot: true,
          rules: [{
            required: true,
            message: "请选择是否覆盖",
            trigger: "blur"
          }]
        },
        {
          label: '模板下载',
          prop: 'excelTemplate',
          formslot: true,
          span: 24,
        }
        ]
      }
    };
  },
  watch: {
    'mode' () {
      this.handleSwitch()
    },
    'excelForm.isCovered' () {
      if (this.excelForm.isCovered !== '') {
        const column = this.findObject(this.excelOption.column, "excelFile");
        column.action = `/api/blade-resource/oss/endpoint/put-file-attach-by-name-new?isCovered=${this.excelForm.isCovered}`;
      }
    },
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList () {
      return {
        addBtn: this.vaildData(this.permission.archives_add, false),
        viewBtn: this.vaildData(this.permission.archives_view, false),
        editBtn: this.vaildData(this.permission.archives_edit, false),
        delBtn: this.vaildData(this.permission.archives_del, false),
        importBtn: this.vaildData(this.permission.archives_import, false),
        exportBtn: this.vaildData(this.permission.archives_export, false),
      };
    },
    ids () {
      let ids = [];
      this.selectionList.forEach(ele => {
        ids.push(ele.id);
      });
      return ids.join(",");
    },
  },
  mounted () {
    this.handleSwitch()
  },
  methods: {
    handleSwitch () {
      if (this.mode == 1) {
        this.option = this.option1;
      } else {
        this.option = this.option2;
      }
      this.$nextTick(() => {
        this.$refs.crud.columnInit();
        this.$refs.crud.init();
        this.onLoad(this.page);
      })
    },
    searchReset () {
      this.query = {};
      this.onLoad(this.page);
    },
    searchChange (params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    selectionChange (list) {
      this.selectionList = list;
    },
    selectionClear () {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    rowDel (row) {
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          if (this.mode == 1) {
            return remove(row.id);
          } else {
            return removeCasearchived(row.id)
          }
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!"
          });
        });
    },
    handleDelete () {
      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          if (this.mode == 1) {
            return remove(this.ids);
          } else {
            return removeCasearchived(this.ids)
          }
        })
        .then(() => {
          // 刷新表格数据并重载
          this.data = [];
          this.$refs.crud.toggleSelection();
          // 表格数据重载
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!"
          });
        });
    },
    currentChange (currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange (pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange () {
      this.onLoad(this.page, this.query);
    },
    onLoad (page, params = {}) {
      this.loading = true;
      let values = {
        ...params,
        ...this.query
      };
      if (this.mode == "1") {
        getList(page.currentPage, page.pageSize, Object.assign(values)).then(res => {
          const data = res.data.data;
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
          this.initData()
        })
      } else {
        getListSuper(page.currentPage, page.pageSize, Object.assign(values)).then(res => {
          const data = res.data.data;
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
          this.initData()
        })
      }

    },
    // 编辑事件
    handleEdit (row) {
      this.$router.push({ path: '/desk/detail', query: { id: row.id } });
    },
    // 查看详情
    handleDetail (row) {
      this.$router.push({ path: `/archives/detail/${row.id}` });
    },
    handlePrintOpen (id) {
      this.dosserId = id
      if (this.mode == 2) {
        getSuperDetail(id).then(res => {
          this.detail = res.data.data.starOrder
          this.orderDetailVisible = true
        })
      } else {
        getArchivesDetail(id).then(res => {
          this.detail = res.data.data
          this.orderDetailVisible = true
        })
      }

    },
    // 用户导入事件
    handleImport () {
      this.excelBox = true;
    },
    // 下载导入模版
    handleTemplate () {
      window.open(`/api/blade-dossier/dossier/exportTemplate?${this.website.tokenHeader}=${getToken()}`);
    },
    // 文件上传成功后回调
    uploadAfter (res, done, loading, column) {
      window.console.log(column);
      this.excelBox = false;
      this.refreshChange();
      done();
    },
    // 导出事件
    handleExport () {
      this.$confirm(`是否导出${this.mode == 1 ? '基础' : '案件'}档案数据?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let str = serialize(emptySurplus({ ids: this.ids, ...this.search }))
        if (str) {
          str = "&" + str
        }
        // window.open(`/api/blade-dossier/dossier/exportDossier?${this.website.tokenHeader}=${getToken()}${str}`);
        if (this.mode == 1) {
          window.open(`/api/blade-basis/basisarchive/export?${this.website.tokenHeader}=${getToken()}${str}`);
        } else {
          window.open(`/api/blade-basis/casearchived/export?${this.website.tokenHeader}=${getToken()}${str}`);
        }
      });
    },
    // 新增走访记录
    openfollowUpHandle (id) {
      this.addFollowDossierId = id
      if (this.mode == 2) {
        caseArchivedFollowUp(id).then(res => {
          this.followUpList = res.data.data
          this.addfollowUpVisit = true
        })
      } else {
        basisListFollowUp(id).then(res => {
          this.followUpList = res.data.data
          this.addfollowUpVisit = true
        })
      }
    },
    addFollowHandle (form, done) {
      if (this.mode == 2) {
        form.caseArchivedId = this.addFollowDossierId
        addCaseFollowUp(form).then(res => {
          console.log(res)

          this.$message.success("添加成功")
          // this.addfollowUpVisit = false
          this.openfollowUpHandle(this.addFollowDossierId)
          this.$refs.addfollowUpForm.resetForm()
          done()

        }).catch(err => {
          console.log(err)
          done()
        })
      } else {
        form.basisArchiveId = this.addFollowDossierId
        addFollowUp(form).then(res => {
          console.log(res)

          this.$message.success("添加成功")
          // this.addfollowUpVisit = false
          this.openfollowUpHandle(this.addFollowDossierId)
          this.$refs.addfollowUpForm.resetForm()
          done()
        }).catch(err => {
          console.log(err)

          done()
        })
      }
    },
    error () {
      this.$message.success('请填写完整信息');
    }
  }
};

</script>
<style>
.none-border {
  border: 0;
  background-color: transparent !important;
}
</style>
